<script lang="ts">
    import ViewDonation from '../../components/admin/donation/viewDonation.svelte';
    export let params: { type: string; id: string };
</script>



<div>
    <ViewDonation params={params} />
</div>